// store/drawerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false
};

const userDrawerSlice = createSlice({
  name: 'userDrawer',
  initialState,
  reducers: {
    openDrawer: state => {
      state.isOpen = true;
    },
    closeDrawer: state => {
      state.isOpen = false;
    },
    toggleDrawer: state => {
      state.isOpen = !state.isOpen;
    }
  }
});

export const { openDrawer, closeDrawer, toggleDrawer } =
  userDrawerSlice.actions;

export default userDrawerSlice.reducer;
